import React from "react";

function StrategicEngagement() {
  const advisoryModels = [
    {
      title: "C-Level Strategy Alignment",
      description: "Define transformation goals for GenAI, CVM, or Data Modernization. Establish ownership and unlock stakeholder buy-in."
    },
    {
      title: "GenAI Readiness Assessment",
      description: "Map ongoing initiatives, assess gaps, and build a roadmap that avoids duplication and accelerates value."
    },
    {
      title: "Capability Blueprint & Tech Stack Review",
      description: "Evaluate AWS usage, data and model infrastructure, agentic readiness, and MLOps maturity."
    },
    {
      title: "Roadmap Co-Development",
      description: "Prioritize use cases, estimate business impact, and plan a 12-18 month transformation journey."
    },
    {
      title: "Governance & Operating Model Design",
      description: "Define roles, escalation paths, and decision rights across business, data, and IT."
    }
  ];

  return (
    <div className="py-12 md:py-18">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-10 md:mb-12 text-white">
            <h2 className="RoobertLight text-3xl md:text-4xl lg:text-5xl font-bold  mb-4">
              Strategic Engagement Models
            </h2>
            <h3 className="RoobertMedium text-xl md:text-2xl font-bold mb-4">
              Clarity before code. Alignment before automation.
            </h3>
            <p className="RoobertRegular text-lg mb-8">
              Before building agents or automating workflows, we help executive teams establish clarity - on where GenAI fits, what success looks like, and how to align the organization.
            </p>
            <p className="RoobertRegular text-lg">
              Our advisory-led entry points include:
            </p>
          </div>

          {/* Advisory Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-16 mb-10">
            {advisoryModels.map((model, index) => (
              <div key={index} className="relative bg-white p-6 md:p-8">
                {/* Green L-shaped border */}
                <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-16 h-16"></div>
                
                <h4 className="RoobertMedium text-lg md:text-xl font-bold text-dark-blue mb-4">
                  {model.title}
                </h4>
                <p className="RoobertRegular text-sm md:text-base text-dark-blue leading-relaxed">
                  {model.description}
                </p>
              </div>
            ))}
          </div>

          {/* Conclusion */}
          <div>
            <p className="RoobertRegular text-lg text-dark-blue leading-relaxed">
              These engagements help clients avoid pilot fatigue - and build the right foundation for enterprise-wide transformation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StrategicEngagement;
